import classNames from 'clsx';
import React from 'react';

import Boost from '../Boost/Boost';
import Decorations from '../Decorations/Decorations';

import styles from './Progress.scss';

export interface Props {
  currentPoints: number;
  targetPoints: number;
  showTierUp: boolean;
  boostRemaining: number;
  expanded?: boolean;
  goingToTierUp: boolean;
  goingToTierDown: boolean;
  cvlConfig: {
    cvl2: boolean;
    showTierDown: boolean;
  };
}

const relativeProgress = (target: number, points: number): number =>
  (points / target) * 100 <= 100 ? (points / target) * 100 : 0;

const getClassName = (props: Props, context: string) => {
  const {
    cvlConfig,
    showTierUp,
    targetPoints,
    currentPoints,
    expanded,
    goingToTierUp,
    goingToTierDown
  } = props;

  return classNames(
    context,
    { [styles.tierUp]: (cvlConfig?.cvl2 && goingToTierUp) || showTierUp },
    { [styles.tierDown]: cvlConfig?.cvl2 && goingToTierDown },
    { [styles.tierComplete]: targetPoints === currentPoints && !goingToTierDown },
    { [styles.tierStart]: currentPoints === 0 },
    { [styles.expanded]: expanded }
  );
};

const Progress: React.FC<Props> = (props) => (
  <span className={getClassName(props, styles.progress)}>
    <span
      className={getClassName(props, styles.progressBar)}
      style={{
        width: `${relativeProgress(props.targetPoints, props.currentPoints)}%`
      }}
    >
      <Decorations {...props} />
    </span>
    <Boost {...props} />
  </span>
);

export { relativeProgress };
export default Progress;
